import { ProductAddIcon, ChatIcon, ImagesIcon, SportsIcon } from "@shopify/polaris-icons";

const config = (cms) => {
  return {
    "/": [
      {
        caption: cms("common.actions.dashboard.caption.addProducts"),
        label: cms("common.actions.dashboard.label.addProducts"),
        icon: ProductAddIcon,
        link: "/products/add",
        key: "product",
      },
      {
        caption: cms("common.actions.dashboard.caption.brand"),
        label: cms("common.actions.dashboard.label.brand"),
        icon: ImagesIcon,
        action: function action() {
          const { token, domain } = this;
          const url = `${domain}/builder/${token}`;
          window.open(url);
        },
        key: "brand",
      },
      {
        caption: cms("common.actions.dashboard.caption.contactUs"),
        label: cms("common.actions.dashboard.label.contactUs"),
        icon: ChatIcon,
        link: "/contact-us",
        key: "contact",
      },
    ],
    "/activity": [
      {
        caption: cms("common.actions.activity.caption.bulk"),
        label: cms("common.actions.activity.label.bulk"),
        link: "/activity/bulk",
        icon: SportsIcon,
      },
    ],
  };
};

export default config;
